export const AuthScheme = {
  legacy_without_sso: 'legacy_without_sso',
  legacy_with_sso: 'legacy_with_sso',
  dsc_universal_login: 'dsc_universal_login',
} as const

export type AuthScheme = (typeof AuthScheme)[keyof typeof AuthScheme]

export interface Auth0AuthorizationParams {
  orgId: string
  clientId: string
  domain: string
  audience: string
}

export interface AuthHint {
  auth_scheme: AuthScheme
  auth0?: Auth0AuthorizationParams
}
